import { type ElfRace } from './elves'

export const elfSurnames: Record<ElfRace, string[]> = {
  'High Elf': [
    'Moonwhisper', 'Starflower', 'Sunwalker', 'Silverleaf', 'Arcaneheart',
    'Celestian', 'Aetherborn', 'Starlight', 'Moonsong', 'Highspire',
    'Glittergem', 'Brightbeam', 'Lorekeeper', 'Spellweaver', 'Miststrider',
    'Cloudancer', 'Ivorytower', 'Crystalshard', 'Eldritch', 'Nobleblood'
  ],
  'Dark Elf': [
    'Do\'Urden', 'Baenre', 'Duskbringer', 'Shadowseeker', 'Webweaver',
    'Nightfall', 'Spiderborn', 'Venomkiss', 'Voidbound', 'Abysswalker',
    'Obsidian', 'Grimblade', '暗影家族', 'Dreadlore', 'Maleficent',
    'Silentstep', 'Bloodlust', 'Viperfang', 'Soulstealer', 'Bottomless'
  ],
  'Wood Elf': [
    'Leafwalker', 'Greenleaf', 'Swiftbow', 'Oakheart', 'Thornrose',
    'Riverdance', 'Wildrunner', 'Forestguide', 'Rootbound', 'Deerfoot',
    'Hawkshadow', 'Pinecrest', 'Mossbeard', 'Barkskin', 'Rainwhisper',
    'Treeminder', 'Foxrun', 'Eagleeye', 'Windrider', 'Berrypicker'
  ],
  'Christmas Elf': [
    'Gumdrop', 'Snowball', 'Sugarplum', 'Jingletree', 'Merrymaker',
    'Peppermint', 'Cocoabean', 'Tinseltoe', 'Frostybeard', 'Northstar',
    'Candycan', 'Giftwrapper', 'Sleighrunner', 'Sparklejoy', 'Wintersun',
    'Hollybranch', 'Mistletoe', 'Evergreen', 'Cookiebake', 'Twinkle'
  ],
  'Half-Elf': [
    'Whitewater', 'Silverhand', 'Oakshadow', 'Moonchild', 'Dawnwalker',
    'Stormborn', 'Ironheart', 'Lightfoot', 'Deepwater', 'Riverson',
    'Gemfinder', 'Stonecarver', 'Mistborn', 'Fairweather', 'Goldpeak',
    'Seabreeze', 'Landstrider', 'Highroad', 'Lowvalley', 'Braveheart'
  ]
}
